<template>
    <div>
        <Modal v-model="$parent.driverListDialog" :mask-closable="false">
            <div slot="header"><strong>Driver ({{driverArr.length}})</strong>
                <Icon type="md-add-circle" style="float: right" size="22" @click="onAddDriver()"></Icon>
            </div>
            <div>
                <Table :columns="driverHeaders" :data="driverArr" max-height="400"
                       :loading="$apollo.queries.driverDetails.loading" v-if="$parent.driverListDialog">
                    <template slot-scope="{ row }" slot="action">
                        <Icon type="md-create" @click="onEditDriver(row)"></Icon>&nbsp;
                        <Icon type="md-close" @click="onDeleteDriver(row.id)"></Icon>
                    </template>
                </Table>
            </div>
            <div slot="footer">
                <Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.driverListDialog=false">CLOSE</Button>
            </div>
        </Modal>

        <Modal v-model="addDriverDialog" :mask-closable="false" width="450" draggable>
            <div slot="header"><strong>{{editMode?'Edit':'New'}} Driver</strong></div>
            <div>
                <Form :model="driverForm" :rules="ruleDriverForm" ref="driverForm" :label-width="95">

                    <FormItem prop="driverType" label="Type">
                    <RadioGroup v-model="driverForm.driverType">
                        <Radio :label="1" :disabled="isLoadedIn?true:false"><span>Tempo driver</span></Radio>
                        <Radio :label="2" :disabled="isLoadedIn?true:false"><span>Truck driver</span></Radio>
                    </RadioGroup>
                    </FormItem>

                  <FormItem label="Status" prop="status">
                    <RadioGroup v-model="driverForm.status">
                      <Radio label="Active"><span>Active</span></Radio>
                      <Radio label="Inactive"><span>Inactive</span></Radio>
                    </RadioGroup>
                  </FormItem>

                    <FormItem prop="transporterName" label="Transporter" v-show="driverForm.driverType==2">
                        <AutoComplete v-model="driverForm.transporterName" v-if="addDriverDialog">
                            <Option v-for="(transporter,index) in transporterArr" :label="transporter.name"
                                    :key="index" :value="transporter.name">
                                <div class="ivu-select-item-div" @click="driverForm.transporterId=transporter.id">
                                    {{transporter.name}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>
                    <FormItem prop="contractorName" label="Contractor" v-show="driverForm.driverType==1">
                        <Select v-model="driverForm.contractorName" filterable>
                            <Option v-for="contractor in contractorArr" :value="contractor.name"
                                    :label="contractor.name" :key="contractor.id">
                                <div class="ivu-select-item-div" @click="driverForm.contractorId=contractor.id"> {{contractor.name}}
                                    <span style="float: right;color:#C0C0C0">{{contractor.contractorCode}}</span></div>
                            </Option>
                        </Select>
                    </FormItem>

                    <FormItem prop="name" label="Name">
                        <Input v-model="driverForm.name"/>
                    </FormItem>

                    <FormItem prop="mobile" label="Mobile Number">
                        <Input type="number" v-model="driverForm.mobile"/>
                    </FormItem>

                    <FormItem prop="proof" label="Proof">
                        <Input v-model="driverForm.proof"/>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addDriver" :loading="loading">
                    <span v-if="!loading">SAVE</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyDriver">UPDATE</Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="addDriverDialog=false">CANCEL</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {ADD_DRIVER, UPDATE_DRIVER, DELETE_DRIVER} from '../../graphql/mutations/vehicle'
    import { GET_DRIVERS} from '../../graphql/queries/vehicle'
    import { SUBSCRIBE_DRIVERS} from '../../graphql/subscription/vehicle'
    import { SEARCH_TRANSPORTER} from '../../graphql/queries/companies'
    import {GET_CONTRACTORS} from '../../graphql/queries/vehicle'
    import { SUBSCRIBE_CONTRACTORS} from '../../graphql/subscription/vehicle'
    import {generateUUID} from '../../Constants/Constant'
    import ValidationRules from '../../Constants/ValidationRules'
    export default {
        apollo: {
            driverDetails: {
                query: GET_DRIVERS,
                variables() {
                    return {
                        driverTypeArr: (this.isLoadedIn==='tempoOrders'||this.isLoadedIn==='contractors')?[1]:(this.isLoadedIn==='truckOrders'?[2]:[1,2])
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_DRIVERS,
                    variables() {
                        return {
                            driverTypeArr: (this.isLoadedIn==='tempoOrders'||this.isLoadedIn==='contractors')?[1]:(this.isLoadedIn==='truckOrders'?[2]:[1,2])
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.driverArr = subscriptionData.data.driverDetails;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.driverArr = data.driverDetails;
                    }
                }
            },
            company: {
                query: SEARCH_TRANSPORTER,
                variables() {
                    return {
                        transporterFilter: this.transporterFilter,
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.transporterArr = data.company;
                    }
                }
            },
            contractor: {
                query: GET_CONTRACTORS,
                subscribeToMore: {
                    document: SUBSCRIBE_CONTRACTORS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.contractorArr = subscriptionData.data.contractor;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.contractorArr = data.contractor;
                    }
                }
            },
        },
        name: "Driver",
        props:['isLoadedIn'],
        data: function(){
            return{
                mutation_ADD_DRIVER: ADD_DRIVER,
                mutation_UPDATE_DRIVER: UPDATE_DRIVER,
                mutation_DELETE_DRIVER: DELETE_DRIVER,
                driverArr: [],
                driverHeaders: [
                    {title: 'Name', key: 'name'},
                    {title: 'Mobile', key: 'mobile'},
                    {title: 'Proof', key: 'proof'},
                    {title: ' ', slot: 'action', width: 80}
                ],
                addDriverDialog: false,
                driverForm:{
                    id: '',
                    status: 'Active',
                    driverType: 1,
                    contractorName: '',
                    contractorId: '',
                    transporterName: '',
                    transporterId: '',
                    name: '',
                    mobile:'',
                    proof: ''
                },
                ruleDriverForm:{
                    name: ValidationRules.textField('Name'),
                    mobile: ValidationRules.mobileNumber,
                    proof: ValidationRules.textField('Proof'),
                },
                transporterArr: [],
                contractorArr: [],
                editMode: false,
                loading: false
            }
        },
        computed: {
            transporterFilter(){
                return '%' + this.driverForm.transporterName + '%'
            }
        },
        methods:{
            reset: function(){
                this.$refs['driverForm'].resetFields();
            },
            onAddDriver(contractorData){
                this.reset();
                this.driverForm.contractorName = '';
                this.driverForm.transporterName = '';
        /* --- change default driverType if loaded in truckorders component ---- */
                if(this.isLoadedIn==='truckOrders'){
                    this.driverForm.driverType = 2
                }
        /* -------x------------x-------------x--------------x--------------x----- */

        /* --- Assign/Autofill Contractor if loaded in contractors component ---- */
                if(this.isLoadedIn==='contractors'){
                    this.driverForm.contractorId = contractorData.id;
                    this.driverForm.contractorName = contractorData.name;
                }
        /* -------x------------x-------------x--------------x--------------x----- */
        /* --- Assign/Autofill Contractor if loaded in transporters component ---- */
                if(this.isLoadedIn==='transporters'){
                    this.driverForm.transporterId = contractorData.id;
                    this.driverForm.transporterName = contractorData.name;
                    this.driverForm.driverType = 2
                }
        /* -------x------------x-------------x--------------x--------------x----- */
                this.editMode = false;
                this.addDriverDialog = true;
            },
            addDriver(){
                this.loading = true;
                this.$refs['driverForm'].validate((valid) => {
                    if (valid) {
                        this.insertDriver();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertDriver(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_DRIVER,
                    variables: {
                        id: generateUUID(),
                        driverType: this.driverForm.driverType,
                        status: this.driverForm.status === 'Active',
                        transporterId: this.driverForm.driverType == 2?this.driverForm.transporterId:'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                        contractorId: this.driverForm.driverType == 1?this.driverForm.contractorId:'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                        name: this.driverForm.name,
                        mobile: this.driverForm.mobile,
                        proof: this.driverForm.proof,
                        skipTransporter: this.driverForm.driverType == 1?true:false
                    }
                })
                if(response.data.insert_driverDetails.returning[0].id){
                    this.$Message.success('New Driver added successfully!');
                    this.reset();
                    this.loading = false
                    this.addDriverDialog = false;
                }
            },
            onEditDriver(driverData){
                this.driverForm.id = driverData.id;
                this.driverForm.driverType = driverData.driverType;
                this.driverForm.status = driverData.status?'Active':'Inactive';
                this.driverForm.transporterId = driverData.Transporter?driverData.Transporter.id:'';
                this.driverForm.transporterName = driverData.Transporter?driverData.Transporter.name:'';
                this.driverForm.contractorId = driverData.Contractor?driverData.Contractor.id:'';
                this.driverForm.contractorName = driverData.Contractor?driverData.Contractor.name:'';
                this.driverForm.name = driverData.name;
                this.driverForm.mobile = driverData.mobile;
                this.driverForm.proof = driverData.proof;
                this.editMode = true;
                this.addDriverDialog = true;
            },
            modifyDriver(){
                this.$refs['driverForm'].validate((valid) => {
                    if (valid) {
                        this.updateDriver();
                    }
                })
            },
            async updateDriver(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_DRIVER,
                    variables: {
                        driverId: this.driverForm.id,
                        driverType: this.driverForm.driverType,
                        status: this.driverForm.status === 'Active',
                        transporterId: this.driverForm.driverType == 2?this.driverForm.transporterId:'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                        contractorId: this.driverForm.driverType == 1?this.driverForm.contractorId:'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                        name: this.driverForm.name,
                        mobile: this.driverForm.mobile,
                        proof: this.driverForm.proof,
                        skipTransporter: this.driverForm.driverType == 1?true:false
                    }
                })
                if(response.data){
                    this.$Message.success('Driver updated successfully!');
                    this.reset();
                    this.addDriverDialog = false;
                }
            },
            onDeleteDriver(driverId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete Driver ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteDriver(driverId, this.$Modal)
                    }
                });
            },
            deleteDriver(driverId, callback){
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_DRIVER,
                    variables: { driverId: driverId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('Driver deleted successfully!');
                }).catch(function(err){
                    callback.remove();
                })
            }
        }
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-table td {
        border-bottom: 0px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    }
</style>
